import { DatePipe } from "@angular/common";
import { PipeTransform, Pipe } from "@angular/core";
import { AppConsts } from "@shared/AppConsts";

@Pipe({
    name: 'datecustom'
})

export class DateCustomPipe extends DatePipe implements PipeTransform {
    transform(value: any, args: any, tz: any): any {
        const locale = abp.localization.currentLanguage.name;
        let formatDate = AppConsts.FormatDate.USShortDate;

        if (locale === 'vi') {
            formatDate = args === 'short' ? AppConsts.FormatDate.VNShort : (args === 'shortTime') ? AppConsts.FormatDate.VNShortTime : AppConsts.FormatDate.VNShortDate;
        } else {
            formatDate = args === 'short' ? AppConsts.FormatDate.USShort : (args === 'shortTime') ? AppConsts.FormatDate.USShortTime : AppConsts.FormatDate.USShortDate;
        }


        return super.transform(value, formatDate, tz);
    }
}